// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2s-2";
export var placeholderIcon = "_2s-3";
export var thumbnailCanvas = "_2s-1";
export var thumbnailWrapper = "_2s-0";